import { Injectable } from '@angular/core';
import VOwnedEntitiesMap from '../../../interfaces/v-owned-entities-map';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { SEARCH_ENTITIES } from '../graphql/document-tracking';
import SqlOperator from '../../../enums/sql-operator';

@Injectable({
  providedIn: 'root',
})
export class AddDocumentDialogService {
  private _entities: VOwnedEntitiesMap[] = [];
  private entities = new BehaviorSubject(this._entities);
  public entities$ = this.entities.asObservable();

  constructor(public apollo: Apollo) {}

  public clearOptions() {
    this._entities = [];
    this.entities.next(this._entities);
  }

  public searchEntities(type: string, name: string) {
    let nameWildcarded = `%${name}%`;
    let sub: Subscription;
    sub = this.apollo
      .query({
        query: SEARCH_ENTITIES,
        variables: {
          where: {
            AND: [
              { column: 'TYPE', operator: SqlOperator.EQ, value: type },
              {
                OR: [
                  {
                    column: 'OWNED_ENTITY_NAME',
                    operator: SqlOperator.LIKE,
                    value: nameWildcarded,
                  },
                  {
                    column: 'RELATED_NAME',
                    operator: SqlOperator.LIKE,
                    value: nameWildcarded,
                  },
                ],
              },
            ],
          },
        },
      })
      .subscribe(({ data }) => {
        if (data?.vOwnedEntityMaps) {
          this._entities = [...data.vOwnedEntityMaps];
          this.entities.next(this._entities);
        }
        sub?.unsubscribe();
      });
  }
}
